export class EmbeddedClientConnection {
    constructor(client, scope) {
        this.client = client;
        this.scope = scope;
    }
    sendMessage(message, category) {
        const envelope = { category: category, scope: this.scope, message: message };
        const window = this.client.getClientWindow();
        if (window) {
            // console.log('EmbeddedClientConnection: posting message', envelope);
            window.postMessage(envelope);
        }
        else {
            console.warn('The following message could not be posted because there is no embedded client.', envelope);
        }
    }
    sendControlMessage(message) {
        this.sendMessage(message, "control" /* EmbeddedMessageCategory.Control */);
    }
}
//# sourceMappingURL=embedded-client-connection.js.map